import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ListHeaderComponent } from '../../../shared/components/list-header/list-header.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { ListContainerComponent } from '../../../shared/components/list-container/list-container.component';
import { DatePipe, NgClass, NgIf } from '@angular/common';
import { SortIconComponent } from '../../../shared/components/sort-icon/sort-icon.component';
import { environment } from '../../../../environments/environment';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { FilterComponent } from '../../../shared/components/filter/filter.component';
import { InputComponent } from '../../../shared/components/input/input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SCondition } from '@nestjsx/crud-request';
import { Pagination } from '../../../shared/services/pagination/pagination';
import { ListLoadingComponent } from '../../../shared/components/list-loading/list-loading.component';
import { RouterLink } from '@angular/router';
import { User } from '../../../shared/models/interfaces/user.interface';
import { UserService } from '../../../shared/services/user2/user.service';
import { PermissionEnum, ResourceEnum } from '../../../../environments/shared-environment/permission';
import { ExportService } from '../../../shared/services/export/export.service';
import { Joins } from '../../../shared/services/pagination/models/typies/joins.type';
import { HasPermission } from '../../../shared/directives/has-permission/has-permission.directive';
import { Disabled } from '../../../shared/directives/disabled/disabled.directive';
import { ContextMenuModule } from 'primeng/contextmenu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { Tooltip } from 'primeng/tooltip';
import { PaginationDto } from '../../../shared/services/pagination/models/interfaces/pagination-dto';

@Component({
    imports: [
        SharedModule,
        TableModule,
        ListHeaderComponent,
        ButtonModule,
        RippleModule,
        IconComponent,
        ListContainerComponent,
        NgIf,
        SortIconComponent,
        ButtonComponent,
        FilterComponent,
        InputComponent,
        ReactiveFormsModule,
        ListLoadingComponent,
        RouterLink,
        HasPermission,
        HasPermission,
        Disabled,
        NgClass,
        DatePipe,
        ContextMenuModule,
        OverlayPanelModule,
        Tooltip,
    ],
    templateUrl: './list.component.html',
    providers: [ExportService]
})
export class ListComponent extends Pagination<User> implements OnInit, OnDestroy {

  private readonly userService = inject(UserService);

  protected readonly exportService = inject(ExportService);

  protected readonly permissionEnum = PermissionEnum;

  protected readonly resourceEnum = ResourceEnum;

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  public async ngOnInit(): Promise<void> {
    this.paramsService.initialize();

    this.paramsService.params = {
      isActive: true,
      sort: { field: 'createdAt', order: 'DESC' },
      userId: 1,
    };

    await this.configPagination({
      route: environment.routes.users.base,
    });

    await this.exportService.configExport({
      route: environment.routes.users.base,
    });
  }

  public async export(): Promise<void> {
    await this.exportService.export();
  }

  public get isExporting(): boolean {
    return this.exportService.isExporting;
  }

  protected override search(): SCondition {
    const searchValue = this.params.search?.trim() ?? '';
    const isActive = this.params.isActive;
    const userId = this.params.userId;

    const filter = {
      ...userId && {
        id: userId,
      },
      ...(isActive !== undefined) && {
        isActive: { $eq: isActive },
      },
    }

    return {
      $or: [
        {
          ...searchValue && {
            name: { $contL: searchValue }, ...filter
          },
          ...filter,
        },
      ]
    };
  }

  protected override join(): Joins {
    return [];
  }

  protected override async loadPaginatedDataMocked(
    _url: string,
    page: number,
    limit: number,
  ): Promise<PaginationDto<User> | null> {
    return this.userService.getMany({
      page,
      limit,
      search: this.search() as any,
      sort: this.sort ? [{ field: this.sort.field, order: this.sort.order }] : undefined,
    });
  }

}
